import { NgClass } from '@angular/common';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event,
  ActivatedRoute,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { appShortcuts } from '../shared/directives/shortcut-key/app-shortcuts.const';
import { NavMenuService } from './nav-menu.service';
import { AppStringsPipe } from '../shared/pipes/appstrings.pipe';
import { MsalService } from '@azure/msal-angular';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    // styleUrls: ['./nav-menu.component.scss'],
    imports: [RouterModule, MatToolbarModule, MatProgressBarModule, NgClass, AppStringsPipe, MatIconModule],
})

export class NavMenuComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();

  protected isExpanded = false;
  protected shortcuts = appShortcuts;
  protected userName: string = "test";
  protected navigatingToRoute: boolean = false;

  private authService = inject(MsalService);
  private navMenuService = inject(NavMenuService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
     iconRegistry.addSvgIcon(
      "face",
      sanitizer.bypassSecurityTrustResourceUrl("/assets/icons/face.svg")
    );

  }

  ngOnInit() {
    this.subscriptions.add(
      this.router.events.subscribe((event: Event) => {
        switch (true) {
          case event instanceof NavigationStart: {
            this.navigatingToRoute = true;
            break;
          }
          case event instanceof NavigationEnd:
          case event instanceof NavigationCancel:
          case event instanceof NavigationError: {
            this.navigatingToRoute = false;
            break;
          }
          default: {
            break;
          }
        }
      }),
    );

    this.subscriptions.add(
      this.navMenuService
        .getUserName()
        .subscribe((result) => (this.userName = result.userName)),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  isActive(url: string): boolean {
    return this.router.isActive(this.router.parseUrl(url), {
      matrixParams: 'subset',
      queryParams: 'ignored',
      paths: 'subset',
      fragment: 'ignored',
    });
  }

  logout() {
    this.subscriptions.add(
      this.authService.logoutRedirect().subscribe({
        error: (error) => console.error('Logout failed', error),
      }),
    );
  }

}
